import { heroWallSrcsetFromJpg, pickBgWebpUrl } from './image-srcset';

const ASSET = '/static/homepage';

function $(id) { return document.getElementById(id); }

function assetUrl(name) {
    if (!name) return '';
    if (name.startsWith('/')) return name;
    if (name.endsWith('.png')) return `${ASSET}/${name}`;
    return `${ASSET}/${name.replace(/\.jpe?g$/i, '.webp')}`;
}

export function initPublicHomeMarketing() {
    document.querySelectorAll('[data-bg]').forEach((el) => {
        const raw = el.getAttribute('data-bg');
        if (raw && !raw.startsWith('/')) el.setAttribute('data-bg', assetUrl(raw));
    });

    const lazy = Array.from(document.querySelectorAll('[data-bg]'));
    const load = (el) => {
        const url = el.getAttribute('data-bg');
        const w = el.clientWidth || el.offsetWidth;
        const picked = pickBgWebpUrl(url, w);
        el.style.backgroundImage = `url('${picked}')`;
        el.removeAttribute('data-bg');
    };
    if (!('IntersectionObserver' in window)) {
        lazy.forEach(load);
    } else {
        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    load(e.target);
                    io.unobserve(e.target);
                }
            });
        }, { rootMargin: '600px 0px' });
        lazy.forEach((el) => io.observe(el));
    }

    const WALLS = [
        { src: 'wall-bouquet.jpg', pos: '40% 35%', by: 'Betto Robles', url: 'https://www.instagram.com/bettoroblesfotografo/' },
        { src: 'wall-parasols.jpg', pos: '50% 55%', by: 'Betto Robles', url: 'https://www.instagram.com/bettoroblesfotografo/' },
        { src: 'hero-betto.jpg', pos: '50% 45%', by: 'Betto Robles', url: 'https://www.instagram.com/bettoroblesfotografo/' },
    ];

    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let wi = Math.floor(Math.random() * WALLS.length);
    let front = $('wallA');
    let back = $('wallB');
    if (!front || !back) return;

    function credit(w) {
        if ($('creditBy')) $('creditBy').textContent = `Photo by ${w.by}`;
        if ($('credit')) $('credit').href = w.url;
    }

    function fill(slot, w, ready) {
        slot.innerHTML = '';
        let once = false;
        const go = () => { if (!once) { once = true; ready?.(); } };
        const im = new Image();
        im.alt = '';
        im.style.objectPosition = w.pos;
        im.onload = go;
        im.onerror = go;
        im.src = assetUrl(w.src);
        const srcset = heroWallSrcsetFromJpg(w.src);
        if (srcset) {
            im.srcset = srcset;
            im.sizes = '100vw';
        }
        slot.appendChild(im);
        if (im.complete) go();
        setTimeout(go, 2500);
    }

    fill(front, WALLS[wi]);
    credit(WALLS[wi]);

    if (WALLS.length > 1 && !still) {
        const next = () => {
            setTimeout(() => {
                if (document.hidden || !$('pAdd') || $('pAdd').hidden) return next();
                wi = (wi + 1) % WALLS.length;
                const w = WALLS[wi];
                fill(back, w, () => {
                    back.classList.add('on');
                    front.classList.remove('on');
                    const t = front;
                    front = back;
                    back = t;
                    credit(w);
                    setTimeout(() => { back.innerHTML = ''; }, 1600);
                    next();
                });
            }, 9000);
        };
        next();
    }

    window.addEventListener('scroll', () => {
        const top = document.querySelector('.top');
        if (!top) return;
        top.classList.toggle('solid', window.scrollY > 40);
    }, { passive: true });

    document.querySelectorAll('.bill [data-bill]').forEach((b) => {
        b.addEventListener('click', () => {
            const m = b.dataset.bill === 'month' ? 'm' : 'y';
            document.querySelectorAll('.bill [data-bill]').forEach((x) => {
                x.setAttribute('aria-checked', x === b ? 'true' : 'false');
            });
            document.querySelectorAll('#pricing [data-y]').forEach((n) => {
                n.textContent = n.getAttribute(`data-${m}`);
            });
            const note = $('billNote');
            if (note) {
                note.textContent = m === 'm' ? 'Monthly plans, cancel anytime.' : '14-day refund on annual plans. Cancel anytime.';
            }
        });
    });

    const fold = $('fold');
    if (fold && 'IntersectionObserver' in window && !still) {
        const cells = Array.from(fold.querySelectorAll('.fs-after b[data-from]'));
        const total = fold.querySelector('.fs-after .fs-tag strong');
        const fmt = (v) => `${(v >= 20 ? Math.round(v) : v.toFixed(1))} MB`;
        cells.forEach((c) => { c.textContent = fmt(+c.dataset.from); });
        if (total) total.textContent = '4.5 GB';
        new IntersectionObserver((entries, o) => {
            entries.forEach((e) => {
                if (!e.isIntersecting) return;
                o.disconnect();
                const t0 = Date.now();
                const D = 1400;
                const step = () => {
                    const k = Math.min(1, (Date.now() - t0) / D);
                    const ease = 1 - Math.pow(1 - k, 3);
                    cells.forEach((c) => {
                        const a = +c.dataset.from;
                        const b = +c.dataset.to;
                        c.textContent = fmt(a + (b - a) * ease);
                    });
                    if (total) total.textContent = `${(4.5 + (1.8 - 4.5) * ease).toFixed(1)} GB`;
                    if (k < 1) requestAnimationFrame(step);
                };
                step();
            });
        }, { threshold: 0.5 }).observe(fold);
    }

    const sc = $('phScroll2');
    const sec = document.querySelector('.m-watch');
    if (sc && sec && !still) {
        let tick = false;
        const move = () => {
            tick = false;
            const r = sec.getBoundingClientRect();
            const vh = window.innerHeight;
            let span = Math.max(1, r.height - vh);
            let p = Math.max(0, Math.min(1, -r.top / span));
            if (window.matchMedia('(max-width: 1080px)').matches) {
                p = Math.max(0, Math.min(1, (vh * 0.6 - r.top) / r.height));
            }
            const max = Math.max(0, sc.scrollHeight - sc.parentNode.clientHeight + 40);
            sc.style.transform = `translateY(${-p * max}px)`;
        };
        window.addEventListener('scroll', () => {
            if (!tick) { tick = true; requestAnimationFrame(move); }
        }, { passive: true });
        window.addEventListener('resize', move);
        move();
    }

    const chat = $('chat');
    if (chat && !still && 'IntersectionObserver' in window) {
        chat.classList.add('wait');
        new IntersectionObserver((entries, o) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    chat.classList.remove('wait');
                    chat.classList.add('play');
                    setTimeout(() => chat.classList.add('done'), 2000);
                    o.disconnect();
                }
            });
        }, { threshold: 0.6 }).observe(chat);
    }
}
